import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { getDepartmentId, getTenantId } from 'src/app/services/store-snapshot.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from './toast.service';

@Injectable()
export class DepartmentCheckInterceptor implements HttpInterceptor {
  constructor(
    private toastService: ToastService,
    private translateService: TranslateService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tenantId = getTenantId();
    if (tenantId) {
      const noDepartments = request.url?.includes(`${tenantId}//`) && !getDepartmentId();
      if (noDepartments) {
        this.translateService.get('userHasNoActiveDepartments').subscribe((value) => {
          this.toastService.error(value);
        });
        return EMPTY;
      }
    }
    return next.handle(request);
  }
}
